export const getFileSelector = state => state.v2FileSelector
export const getAttachments = (state) => getFileSelector(state).attachments || []
